import { useCallback, useEffect, useState } from 'react';
import { getViaAuth, responseValidator } from '../../../../../apis/api';

/**
 * Loads a settings payload on mount. The backend `ApiResult<T>` puts the payload
 * on `.value`, so that's what we read.
 */
export function useLoadSettings<T>(url: string, setCardLoading?: (loading: boolean) => void) {
    const [data, setData] = useState<T>();

    const reload = useCallback(async () => {
        setCardLoading?.(true);
        const res: any = await getViaAuth<T>(url);
        setCardLoading?.(false);
        if (responseValidator(res.status) && res.value) {
            setData(res.value as T);
        }
    }, [url]);

    useEffect(() => {
        reload();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { data, setData, reload };
}
